import { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Fusionne les classes Tailwind avec clsx pour une gestion optimale
 * Déduplique les classes et résout les conflits Tailwind
 */
export function cn(...inputs: ClassValue[]) {
  // First filter out falsy values and convert arrays
  const filtered = inputs.filter((input): input is NonNullable<ClassValue> => 
    input != null && input !== ''
  );
  
  // Deduplicate while preserving order
  const seen = new Set<string>();
  const unique: string[] = [];
  
  for (const input of filtered) {
    if (typeof input === 'string') {
      if (!seen.has(input)) {
        seen.add(input);
        unique.push(input);
      }
    } else if (typeof input === 'object') {
      // Handle objects like { 'class': true }
      for (const [key, value] of Object.entries(input)) {
        if (value && !seen.has(key)) {
          seen.add(key);
          unique.push(key);
        }
      }
    }
  }
  
  return twMerge(unique.join(' '));
}

/**
 * Formate une date selon le locale français
 */
export function formatDate(date: Date | string, options?: Intl.DateTimeFormatOptions): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...options,
  }).format(d);
}

/**
 * Formate une heure
 */
export function formatTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

/**
 * Génère un UUID v4
 */
export function generateId(): string {
  return crypto.randomUUID();
}
